import React, { useEffect } from 'react';
import Button from '../../../Button';

/**
 * Step 4: Test PDF Preview
 *
 * Purpose: Display generated PDF preview
 *
 * Features:
 * - Show PDF in iframe
 * - Download PDF option
 * - Option to go back and regenerate
 */
const Step4_TestPdfPreview = ({
  wizardData,
  onDataChange,
  onValidationChange,
  onBackToTest
}) => {
  useEffect(() => {
    // This step is always valid
    onValidationChange(true);
  }, [onValidationChange]);

  const handleDownloadPdf = () => {
    if (wizardData.testPdfUrl) {
      const link = document.createElement('a');
      link.href = wizardData.testPdfUrl;
      link.download = `${wizardData.title.replace(/\s+/g, '_')}_test.pdf`;
      link.click();
    }
  };

  const handleBackToTest = () => {
    // Clear test PDF URL
    onDataChange({
      ...wizardData,
      testPdfUrl: null
    });

    if (onBackToTest) {
      onBackToTest();
    }
  };

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-semibold mb-4">Test PDF Preview</h3>
        <p className="text-sm text-gray-600 mb-6">
          Review the generated PDF output
        </p>
      </div>

      {wizardData.testPdfUrl ? (
        <>
          {/* Action buttons */}
          <div className="flex gap-3 mb-4">
            <Button
              onClick={handleDownloadPdf}
              variant="primary"
            >
              📥 Download Test PDF
            </Button>
            <Button
              onClick={handleBackToTest}
              variant="outline"
            >
              ← Regenerate with Different Data
            </Button>
          </div>

          {/* PDF Preview */}
          <div className="bg-white border border-gray-200 rounded-lg p-6">
            <h4 className="text-sm font-semibold text-gray-500 mb-4">PDF Preview</h4>
            <div className="border rounded-lg overflow-hidden" style={{ height: '600px' }}>
              <iframe
                src={wizardData.testPdfUrl}
                title="Test PDF Preview"
                width="100%"
                height="100%"
                style={{ border: 'none' }}
              />
            </div>
          </div>

          {/* Info */}
          <div className="bg-green-50 border border-green-200 text-green-700 px-4 py-3 rounded">
            <p className="text-sm">
              ✓ PDF generated successfully! Review it above, then click "Next" to proceed to create the template.
            </p>
          </div>
        </>
      ) : (
        <div className="bg-yellow-50 border border-yellow-200 text-yellow-700 px-4 py-3 rounded">
          <p className="text-sm">
            No PDF has been generated yet. Go back to the Preview step and click "Generate Test PDF".
          </p>
        </div>
      )}
    </div>
  );
};

export { Step4_TestPdfPreview };
